import { Dispatch, SetStateAction, useCallback } from 'react';
import { TInsertLiteratureCitationDialogState } from '../types/internal.types';

type TParams = {
  setInsertLiteratureCitationDialogState: Dispatch<SetStateAction<TInsertLiteratureCitationDialogState | undefined>>;
};

const useInsertLiteratureCitation = ({ setInsertLiteratureCitationDialogState }: TParams) => {
  return useCallback(() => {
    setInsertLiteratureCitationDialogState({ isOpen: true });
  }, [setInsertLiteratureCitationDialogState]);
};

export default useInsertLiteratureCitation;
